<template>
  <div class="gradient-row1">
    <div class="Directions">
      <h4>使用说明</h4>
      <h5>介绍</h5>
      <div class="text-list-row">
        <p>
          买了基金后，一直想找一款pc端的chrome扩展插件，毕竟股票的交易时间都是在工作日进行的，可惜找不到，便打算自己写一个，忍痛花费5美刀上架扩展商店。扩展的形式很适合上班族，不用打开网站，仅以小窗口的形式展示，不会引起BOSS的注意，方便上班摸鱼。
        </p>
      </div>
      <h5>如何使用</h5>
      <div class="text-list-row">
        <p>
          首先点击编辑按钮，在“添加新基金”输入框中输入基金代码（支持按拼音、汉字、编码模糊搜索，支持批量添加）添加需要关注的基金，基金列表支持拖拽排序，顶部的大盘指数信息也支持自定义。
        </p>
        <p>
          可以点击基金名称或指数名称，进入详情页面，查看走势图与持仓明细等基金详情；在基金持仓明细页，可以点击对应股票名称，查看对应股票的详情走势图。
        </p>
        <p>
          更多功能可以通过设置按钮进入设置页面，可以开启角标提醒功能，调整展示内容；可以开启显示估值收益，显示持有收益，开启后可以在编辑按钮中填入持有份额与成本价，插件会自动计算对应的收益情况。
        </p>
        <p>
          节假日信息一般每年一更新，可以在节假日是自动暂停实时更新，避免不必要的网络请求。关于个人的基金配置信息，插件本身支持跟随浏览器账号自动同步，若想手动同步可使用设置界面的导入导出功能。
        </p>
      </div>
      <div class="img-row">
        <img style="margin: 10px;" />
        <el-image
          fit="contain"
          src="https://github.com/x2rr/Picture/raw/master/img/popup1-dark.png"
          alt="暗色模式"
        ></el-image>
        <p>暗色模式</p>
      </div>
      <div class="img-row">
        <el-image
          fit="contain"
          src="https://github.com/x2rr/Picture/raw/master/img/edit.png"
          alt="编辑页面"
        ></el-image>
        <p>编辑页面</p>
      </div>
      <div class="img-row">
        <el-image
          fit="contain"
          src="https://github.com/x2rr/Picture/raw/master/img/fund-detail.png"
          alt="基金详情"
        ></el-image>
        <p>基金详情</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.gradient-row1 {
  background: #e0e6f0;
  padding-top: 70px;
}
.Directions {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 15px;
  margin: 0 auto;

  h4 {
    font-size: 30px;
    margin: 40px 0 20px;
  }
  h5 {
    font-size: 24px;
    margin: 10px 0 30px;
  }

  .text-list-row {
    max-width: 850px;
    margin: 0 auto;
    p {
      text-align: justify;
      text-indent: 2em;
      font-size: 17px;
    }
  }
  .img-row {
    padding: 40px 0;
    .el-image {
      max-width: 100%;
      box-shadow: 0 0 10px #666;
    }
  }
}
</style>
